import type { FC, PropsWithChildren } from 'react';

import ContentsEditorLogo from '~assets/graphics/graphic-logo.png';

const DeviceGuard: FC<PropsWithChildren> = ({ children }) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <main className="w-full h-screen flex flex-col gap-y-8 items-center justify-center p-4 bg-white">
        <img src={ContentsEditorLogo} alt="PC 전용" width={164} height={56} />
        <hr className="w-full border-CoolGray-100" />
        <div className="text-center">
          <h2 className="text-[22px] font-bold text-gray-800 mb-2">
            똑닥 콘텐츠 에디터는
            <br /> PC 환경에서만
            <br /> 접속 가능 합니다.
          </h2>
        </div>
      </main>
    );
  }

  return <>{children}</>;
};

export default DeviceGuard;
